import { App, Form } from 'antd';
import { useRef, useState } from 'react';

export default function useSendNoteForm({ mutation }) {
  const { notification } = App.useApp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const editorRef = useRef(null);
  const modalEditorRef = useRef(null);

  const onFinish = (values) => {
    if (!values.content) return;
    mutation.mutate(
      { content: values.content.replaceAll('\r\n', '\n') },
      {
        onSuccess: () => {
          editorRef.current?.setValue('');
          form.resetFields();
        },
        onError: (error) => {
          notification.open({
            className: 'notification-dialogue-error',
            message: error.message,
          });
        },
      }
    );
  };

  const closeModal = () => {
    editorRef.current?.setValue(form.getFieldValue('content') || '');
    setIsModalOpen(false);
  };

  const modalProps = {
    open: isModalOpen,
    onClose: closeModal,
    title: 'Note interne',
    editorRef: modalEditorRef,
    placeholder: 'Saisissez votre note interne',
    defaultValue: form.getFieldValue('content') || '',
    onChange: (value) => form.setFieldsValue({ content: value }),
    onSubmit: () => form.submit(),
    submitText: 'Enregistrer',
    loading: mutation.isPending,
    disabled: mutation.isPending,
  };

  return { form, editorRef, isModalOpen, setIsModalOpen, onFinish, modalProps };
}
